// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"22":"c5166536","25":"df0e88a3","31":"b738f018","173":"a1987996","450":"f08789a8","831":"c5166536","912":"c5166536"}[chunkId] + ".chunk.css";
};